/* eslint-disable max-len */
import { ICoinPageData } from 'pages/loans/[coin]/assets/page-data/types'
import bnbQuestions from 'images/coin-pages/questions/bnb.svg'

import { commonLearnMoreData, commonSlidesData } from '../commonPageData'

export const bnbPage: ICoinPageData = {
  title: 'coin_153',
  description: 'coin_154',
  // description:
  //   'Borrow Fantom against Stablecoins.' +
  //   ` Get a stablecoin loan using your BNB coin as collateral for ${PERCENTAGES.loan}% APR for an unlimited term.`,
  h1: (t, _, replacePlaceholders) => (
    <span dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Binance (BNB)' }) }} />
  ),
  questionsBlock: {
    image: bnbQuestions,
    questions: [
      {
        title: 'coin_155',
        answer: 'coin_156',
      },
      {
        title: 'coin_157',
        answer: 'coin_158',
      },
      {
        title: 'coin_159',
        answer: 'coin_160',
      },
      {
        title: 'coin_161',
        answer: 'coin_162',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('Binance (BNB)'),
    text: [],
    paragraphs: [
      {
        title: 'coin_163',
        text: ['coin_165'],
      },
      {
        title: 'coin_164',
        text: ['coin_166'],
      },
    ],
    ...commonLearnMoreData('Binance (BNB)'),
  },
}
